import { cn } from '@/lib/utils';

/**
 * Shared surfaces for the submit walkthrough — aligned with SegmentedControl
 * (gray rest, white focus/selected).
 */

/** Resting surface for text fields on the page background. */
export const formFieldRestSurface = cn(
  'bg-white dark:bg-slate-800',
  'ring-1 ring-slate-300/80 dark:ring-slate-600/60',
  'hover:ring-slate-400/80 dark:hover:ring-slate-500/60'
);

/** Focused text field — matches selected segmented control segment. */
export const formFieldFocusSurface = cn(
  'focus:bg-white dark:focus:bg-slate-600',
  'focus:shadow-sm focus:ring-slate-200/80 dark:focus:ring-slate-500/50',
  'focus:outline-none'
);

/** Selected choice chip/segment (e.g. privacy toggle, gender pill). */
export const choiceSelectedSurface = cn(
  'bg-primary-50 dark:bg-primary-900/40',
  'text-primary-900 dark:text-primary-100',
  'ring-2 ring-primary-500 dark:ring-primary-400',
  'shadow-sm'
);

/** Unselected segment sitting on a segmented control track. */
export const choiceUnselectedOnTrackSurface = cn(
  'bg-white/40 dark:bg-slate-700/40 text-slate-600 dark:text-slate-400',
  'ring-1 ring-slate-200/60 dark:ring-slate-600/50',
  'hover:bg-white/70 dark:hover:bg-slate-700/60 hover:text-slate-900 dark:hover:text-slate-200'
);

/** Unselected standalone choice (e.g. gender pill off-track). */
export const choiceUnselectedSurface = cn(
  formFieldRestSurface,
  'text-slate-600 dark:text-slate-400',
  'hover:text-slate-900 dark:hover:text-slate-200'
);

/** Segmented control track behind option buttons. */
export const choiceTrackSurface = 'bg-slate-200/90 dark:bg-slate-800';
